<template>
  <button
      :class="{
    'cursor-pointer px-4 py-1.5 text-13px rounded transition-colors text-white text-center': true,
    'bg-red-cardinal hover:bg-red-cardinal-dark': theme === 'red',
    'bg-brown-thunder hover:bg-black': theme === 'dark',
    'bg-gray-60 hover:opacity-90 transition-opacity': theme === 'gray'
      }" @click="onClick">
    <slot>Button</slot>
  </button>
</template>

<script>
export default {
  props: {
    onClick: {
      type: Function,
      required: true
    },
    theme: {
      type: String,
      default: 'red'
    }
  }
}
</script>